<template>
  <div />
</template>

<script>
export default {
  name: 'Email',
  created() {
    const {
      query: { redirect },
    } = this.$route;

    this.$router.push(redirect || '/').catch(() => {});
  },
};
</script>
